import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FiLogOut } from 'react-icons/fi';

const MenuContainer = styled.div`
  width: ${props => (props.open ? (props.collapsed ? '60px' : '250px') : '0')};
  background-color: #f8f8f8;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  transition: all 0.3s ease;
  z-index: 1000;
  overflow: hidden; /* 👈 Ensures nothing leaks visually */

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    width: ${props => (props.open ? (props.collapsed ? '60px' : '80%') : '0')};
    box-shadow: ${props => (props.open ? '2px 0 10px rgba(0,0,0,0.3)' : 'none')};
    pointer-events: ${props => (props.open ? 'auto' : 'none')}; /* 👈 Prevent clicks */
    background-color: ${props => (props.open ? '#f8f8f8' : 'transparent')}; /* 👈 Hide background */
  }
`;


const MenuContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 60px;
  padding-left: ${props => (props.collapsed ? '10px' : '20px')};
  padding-right: ${props => (props.collapsed ? '10px' : '20px')};
`;

const OverlayBackdrop = styled.div`
  @media (max-width: 768px) {
    display: ${props => (props.show ? 'block' : 'none')};
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.4);
    z-index: 999;
  }
`;

const BurgerButton = styled.button`
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 1100;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;

  @media (min-width: 769px) {
    position: absolute;
    z-index: 10;
  }
`;

const MenuItem = styled(Link)`
  display: ${props => props.collapsed ? 'none' : 'block'};
  padding: 10px 15px;
  text-decoration: none;
  color: #333;
  border-radius: 5px;
  margin-bottom: 5px;
  &:hover {
    background-color: #f0f0f0;
  }
  background-color: ${props => props.active ? '#e0e0e0' : 'transparent'};
`;

const permissionDisplayNames = {
  Sign: 'Fichar',
  CreateEmployee: 'Añadir Empleado',
  UpdateEmployee: 'Modificar Empleado',
  DataExport: 'Exportar datos',
  AdminDataExport: 'Exportar datos',
  AdminAddLeave: 'Registrar Ausencia',
  AddLeave: 'Registrar Ausencia',
  FillDays: 'Rellenar días',
  ListLeave: 'Lista de Ausencias',
  AdminListLeave: 'Lista de Ausencias',
  AdminAddHoliday: 'Añadir Festivos',
  AdminListHoliday: 'Lista de Festivos'
};

const Avatar = styled.div`
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  border-radius: 50%;
  background: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 0.9rem;
`;

const UserDropdown = styled.div`
  position: absolute;
  bottom: 60px;
  left: ${props => (props.collapsed ? '10px' : '20px')};
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  width: ${props => (props.collapsed ? '150px' : '200px')};
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  z-index: 1001;
  transition: all 0.2s ease;
`;

const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 10px;
  cursor: pointer;
  color: #333;
  border-radius: 4px;
  font-size: 0.95rem;

  &:hover {
    background-color: #f5f5f5;
  }
`;


const UserSection = styled.div`
  width: 100%;
  padding: 10px ${props => (props.collapsed ? '0' : '20px')};
  border-top: 1px solid #e0e0e0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: ${props => (props.collapsed ? 'center' : 'flex-start')};
  box-sizing: border-box;
  position: relative;
  
  @media (max-width: 768px) {
    /* Agrega estilos específicos para móviles aquí */
    padding: 15px; /* Ejemplo */
    justify-content: ${props => (props.collapsed ? 'center' : 'flex-start')};
	padding-bottom: ${props => props.viewportHeight * 0.15}px;
  }
`;

const ScrollableArea = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 60px;
  padding-left: ${props => (props.collapsed ? '10px' : '20px')};
  padding-right: ${props => (props.collapsed ? '10px' : '20px')};
`;



const Menu = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [open, setOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [userName, setUserName] = useState(localStorage.getItem('userName') || 'Usuario');
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  const location = useLocation();
  const navigate = useNavigate();
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

    useEffect(() => {
      const handleResize = () => {
        setViewportHeight(window.innerHeight);
      };
      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

  const handleLogout = async () => {
    try {
      await api.post('/logout');
    } catch (e) {
      console.warn("Logout request failed:", e);
    } finally {
      localStorage.clear();
      navigate("/login", { replace: true });
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth <= 768;
      setIsMobile(isNowMobile);
      setOpen(!isNowMobile);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      {isMobile && open && <OverlayBackdrop show onClick={() => setOpen(false)} />}
		
		{isMobile && (
        <BurgerButton onClick={() => setOpen(!open)}>
          ☰
        </BurgerButton>
      )}
	  {(open || !isMobile) && (
     <MenuContainer collapsed={collapsed} open={open}>
  {!isMobile && (
  <BurgerButton
    onClick={() => {
      setCollapsed(prev => {
        const next = !prev;
        if (next) setShowUserDropdown(false); // ✅ close dropdown when collapsing
        return next;
      });
    }}
  >
    ☰
  </BurgerButton>
)}

  <ScrollableArea collapsed={collapsed}>
    {permissions.map((permission, index) => (
      <MenuItem
    key={index}
    to={`/${permission.toLowerCase()}`}
    active={location.pathname === `/${permission.toLowerCase()}`}
    collapsed={collapsed}
    onClick={() => {
      if (isMobile) setOpen(false);
    }}
  >
    {permissionDisplayNames[permission] || permission}
  </MenuItem>
    ))}
	</ScrollableArea>

  <UserSection viewportHeight={viewportHeight}
  collapsed={collapsed}
  onClick={() => setShowUserDropdown(!showUserDropdown)}
  title={collapsed ? userName : ''}
>
    <Avatar>{userName[0]?.toUpperCase()}</Avatar>
    {!collapsed && <span style={{ marginLeft: '10px' }}></span>}
    {showUserDropdown && (
      <UserDropdown collapsed={collapsed}>
        <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>{userName}</div>
        <DropdownItem onClick={handleLogout}>
          <FiLogOut size={16} style={{ marginRight: '8px' }} />
		  Logout
        </DropdownItem>
      </UserDropdown>
    )}
  </UserSection>
</MenuContainer>
)}


    </>
  );
};

export default Menu;
